// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__322f1","title":"Images45_title__14r4U","images":"Images45_images__1bMqS"};